<!--
  ~ Copyright (c) Worldline 2022.
  -->

<!DOCTYPE html>

<!-- Title -->
<h3>{{ 'cropping.title' | translate }} <strong>{{ 'evidences.type.' + evidenceWithTemp.evidenceDto.evidenceType.type | translate }}</strong></h3>
<!-- Main section -->
<div class="croppingSection content" id="croppingSection">

    <!-- Image to affect/crop -->
    <img [src]="imageCropLink" class="evToCrop"/>

    <!-- Information on number of pages to affect/crop -->
    <h5>{{ 'evidences.elementtype.PAGE' | translate}} {{currentTempPage}}/{{nbPages}}</h5>
    <!-- *ngIf="evidenceWithTemp.evidenceTempDataDto.externalEvidenceTempDataStatus !== 'TO_CROP'"-->
    <!-- Buttons to select a part or keep/skip current page -->
    <ul class="affectPartChoice" id="affectPartChoiceSection">
        <!-- Error message -->
        <div class="error-form" *ngIf="croppingMsg">{{ croppingMsg | translate }}</div>

        <!-- Explanation text on actions to do if evidence is not multi content type -->
        <h5 *ngIf="evidenceWithTemp.evidenceDto.evidenceContentType !== evidenceContentType.MULTI && evidenceWithTemp.evidenceTempDataDto.externalEvidenceTempDataStatus !== 'TO_CROP'">
            {{ 'cropping.dispatch' | translate }}</h5>
        <h5 *ngIf="evidenceWithTemp.evidenceDto.evidenceContentType !== evidenceContentType.MULTI && evidenceWithTemp.evidenceTempDataDto.externalEvidenceTempDataStatus === 'TO_CROP'">
            {{ 'cropping.crop' | translate }}</h5>
        <!-- Explanation text on actions to do if evidence is multi content type -->
        <h5 *ngIf="evidenceWithTemp.evidenceDto.evidenceContentType === evidenceContentType.MULTI">
            {{ 'cropping.dispatch-multi' |
            translate:dataToReplace }}</h5>

        <div [ngClass]="{'affectPartButton': evidenceWithTemp.evidenceDto.evidenceContentType !== evidenceContentType.MULTI,
                        'affectMultiPartButton': evidenceWithTemp.evidenceDto.evidenceContentType === evidenceContentType.MULTI}">
            <div *ngIf="evidenceWithTemp.evidenceTempDataDto.externalEvidenceTempDataStatus !== 'TO_CROP'">
                <!-- If evidence is not multi type, display one button per part -->
                <div *ngIf="evidenceWithTemp.evidenceDto.evidenceContentType !== evidenceContentType.MULTI">
                <span *ngFor="let part of evidenceWithTemp.evidenceDto.parts; let index = index">
                <li type="button" class="k-button"
                    [ngClass]="{'typeChoice': !affectInProgress, 'typeChoice-disabled': affectInProgress}"
                    [attr.disabled]="affectInProgress ? 'disabled' : null"
                    (click)="sendCroppingData(part.extEvidencePartId)"
                    id="affectChoiceButton_{{index}}">
                    <!-- Case evidence is named part type -->
                    <span id="affectChoiceButton-named_{{index}}"
                          *ngIf="evidenceWithTemp.evidenceDto.evidenceContentType === evidenceContentType.NAMED_PARTS">{{'evidences.type.' + evidenceWithTemp.evidenceDto.evidenceType.type + '_' + part.partName | translate}}</span>
                    <!-- Case evidence is multi part type -->
                    <span id="affectChoiceButton-multi_{{index}}"
                          *ngIf="evidenceWithTemp.evidenceDto.evidenceContentType === evidenceContentType.SINGLE">{{ 'evidences.type.' + evidenceWithTemp.evidenceDto.evidenceType.type | translate }}</span>
                </li>
                <input type="button" [disabled]="affectInProgress"
                       class="k-help-typeChoice ic-help" id="help-affectChoiceButton_{{index}}"
                       (click)="openPopoverEvidenceToCrop('help-affectChoiceButton_'+index)"
                       title="{{ 'evidences.evidence.help' | translate }}"/>

                    <!-- Popover to help user with a lookalike of a part/evidence -->
                <span *ngIf="rootScope.get().popoverTable['help-affectChoiceButton_'+index]">
                    <app-wl-popover
                            id="{{ 'popover-help-affectChoiceButton_'+index }}"
                            [popoverId]="'popover-help-affectChoiceButton_'+index"
                            [contenttype]="evidenceWithTemp.evidenceDto.evidenceContentType"
                            [evidencetype]="evidenceWithTemp.evidenceDto.evidenceType"
                            [partname]="part.partName"
                            [buttonid]="'affectChoiceButton_'+index"
                            [evidencestate]="popoverMode.dispatchEvidencePart">
                    </app-wl-popover>
                </span>
            </span>
                </div>

                <!-- If evidence is multi type, juste display one button -->
                <span *ngIf="evidenceWithTemp.evidenceDto.evidenceContentType === evidenceContentType.MULTI">

                <!-- If part concerned by original upload is available, display a keep button for that part -->
                <span *ngIf="evidenceWithTemp.evidenceDto.parts[partIndex].uploadDate === null">
                    <li type="button" class="k-button"
                        [ngClass]="{'typeChoice': !affectInProgress, 'typeChoice-disabled': affectInProgress}"
                        [attr.disabled]="affectInProgress ? 'disabled' : null"
                        (click)="sendCroppingData(evidenceWithTemp.evidenceTempDataDto.extEvidencePartId)"
                        id="affectChoiceButtonKeep1">{{ 'cropping.keep' | translate }} {{ 'evidences.elementtype.' + evidenceWithTemp.evidenceDto.parts[0].elementType | translate }} {{ evidenceWithTemp.evidenceDto.parts[partIndex].partName }}</li>
                    <input type="button" [disabled]="affectInProgress"
                           class="k-help-typeChoice ic-help" id="help-affectChoiceButtonKeep1"
                           (click)="openPopoverEvidenceToCrop('help-affectChoiceButtonKeep1')"
                           title="{{ 'evidences.evidence.help' | translate }}"/>
                    <!-- Popover to help user with a lookalike of a part/evidence -->
                    <span *ngIf="rootScope.get().popoverTable['help-affectChoiceButtonKeep1']"
                          wl-popover
                          contenttype="evidenceWithTemp.evidenceDto.evidenceContentType"
                          evidencetype="evidenceWithTemp.evidenceDto.evidenceType"
                          partname="null" buttonid="'affectChoiceButtonKeep1'"
                          evidencestate="popoverMode.dispatchEvidencePart"></span>
                </span>

                    <!-- If part concerned by original upload is already filled, display a keep button for next available part -->
                <span *ngIf="evidenceWithTemp.evidenceDto.parts[partIndex].uploadDate !== null">
                    <li type="button" class="k-button"
                        [ngClass]="{'typeChoice': !affectInProgress, 'typeChoice-disabled': affectInProgress}"
                        [attr.disabled]="affectInProgress ? 'disabled' : null"
                        (click)="sendCroppingData(evidenceWithTemp.evidenceTempDataDto.extEvidencePartId)"
                        id="affectChoiceButtonKeep2">{{ 'cropping.keep' | translate }} {{ 'evidences.elementtype.' + evidenceWithTemp.evidenceDto.parts[0].elementType | translate }} {{ newPartIndex }}</li>
                    <input type="button" [disabled]="affectInProgress"
                           class="k-help-typeChoice ic-help" id="help-affectChoiceButtonKeep2"
                           (click)="openPopoverEvidenceToCrop('help-affectChoiceButtonKeep2')"
                           title="{{ 'evidences.evidence.help' | translate }}"/>
                    <!-- Popover to help user with a lookalike of a part/evidence -->
                    <span *ngIf="rootScope.get().popoverTable['help-affectChoiceButtonKeep2']"
                          wl-popover
                          contenttype="evidenceWithTemp.evidenceDto.evidenceContentType"
                          evidencetype="evidenceWithTemp.evidenceDto.evidenceType"
                          partname="null" buttonid="'affectChoiceButtonKeep2'"
                          evidencestate="popoverMode.dispatchEvidencePart"></span>
                </span>
            </span>
            </div>
            <li type="button" *ngIf="evidenceWithTemp.evidenceTempDataDto.externalEvidenceTempDataStatus === 'TO_CROP'" class="k-button"
                [ngClass]="{'typeChoice': !affectInProgress, 'typeChoice-disabled': affectInProgress}" id="confirm-crop"
                [attr.disabled]="affectInProgress ? 'disabled' : null"
                (click)="sendCroppingData(evidenceWithTemp.evidenceTempDataDto.extEvidencePartId)">{{
                'cropping.select' | translate }}
            </li>
            <!-- Skip button to ignore current displayed page -->
            <li type="button" class="k-optional"
                [ngClass]="{'typeChoice': !affectInProgress, 'typeChoice-disabled': affectInProgress}"
                [attr.disabled]="affectInProgress ? 'disabled' : null" (click)="skipCropping()" id="ignore-crop">{{
                'cropping.skip' | translate }}
            </li>
        </div>
    </ul>


</div>